// extracted by mini-css-extract-plugin
export default {"ContentImage":"ContentImage_ContentImage__n5gWV"};